<template>
    <el-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="30%">
        <slot name="dialog-content" :data="dialogFormData">这是一段信息</slot>
        <span slot="footer" class="dialog-footer">
            <el-button type="danger" @click="cancel()">{{cancelText}}</el-button>
            <el-button type="primary" @click="confirm">{{confirmText}}</el-button>
        </span>
    </el-dialog>
</template>
<script>
    import BasicModel from '@/framework/basic/BasicModel'
    export default {
        name:"clue-dialog",
        data() {
            return {
                dialogFormData:{},
                dialogVisible: false
            };
        },
        props:{
            requestUrl:{
                type:String,
                default: function(){
                    return null
                }
            },
            title:{
                type: String,
                default(){
                    return "温馨提示"
                }
            },
            confirmText:{
                type:String,
                default: function(){
                    return "确定"
                }
            },
            confirmValue:{
                type:Object,
                default: function(){
                    return null
                }
            },
            cancelText:{
                type:String,
                default: function(){
                    return "取消"
                }
            },
            cancelValue:{
                type:Object,
                default: function(){
                    return null
                }
            }
        },
        methods: {
            show(data){
                this.dialogVisible = true
                this.dialogFormData = data
            },
            cancel(){
                this.$confirm('确认'+this.cancelText+"?")
                    .then(_ => {
                        if(this.cancelValue){
                            let newData = Object.assign(this.dialogFormData,this.cancelValue)
                            this.dialogFormData = newData
                            this.submit()
                        }else{
                            this.dialogVisible = false
                        }
                    })
                    .catch(_ => {});

            },
            confirm(){

                this.$confirm('确认'+this.confirmText+"?")
                    .then(_ => {
                        if(this.confirmValue){
                            let newData = Object.assign(this.dialogFormData,this.confirmValue)
                            this.dialogFormData = newData
                            this.submit()
                        }else{
                            this.dialogVisible = false
                        }
                    })
                .catch(_ => {});


            },
            submit(){
                let that = this
                BasicModel.post(that,this.requestUrl,this.dialogFormData,{
                    success:function(dataInfo){
                        that.$emit('confirm',dataInfo)
                        that.dialogVisible = false
                    }
                })
            }
        }
    };
</script>